import { Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { TABLEAU_CHARTS } from '../../../utils/tableau';
import Loader from 'components/ui/LoadingIndicator';

import { Grid } from '@mui/material';

interface TableauChartsListProps {
    onSelect: (chart: any) => void;
}

interface TableauChart {
    id: string;
    title: string;
    path: string;
    image: string;
}

export const TableauChartsList: React.FC<TableauChartsListProps> = ({
    onSelect,
}) => {
    const { data, loading } = useQuery<{ getTableauCharts: TableauChart[] }>(
        TABLEAU_CHARTS
    );
    const views = useMemo(() => {
        if (!data) return [];
        return data.getTableauCharts;
    }, [data]);

    const capture = (selectedChart: TableauChart, e: React.MouseEvent) => {
        onSelect(selectedChart);
        e.stopPropagation();
        e.preventDefault();
    };

    if (loading)
        return (
            <div style={{ minWidth: 400, minHeight: 400 }}>
                <Loader minHeight={400} />
            </div>
        );

    return (
        <Grid container spacing={2}>
            {views.map((v) => (
                <Grid
                    key={v.id}
                    style={{ cursor: 'pointer' }}
                    onClickCapture={(e) => capture(v, e)}
                    size={4}
                >
                    <img alt={v.path} style={{ width: '100%' }} src={v.image} />
                    <Typography variant="caption">{v.title}</Typography>
                </Grid>
            ))}
        </Grid>
    );
};
